import { REQUEST_KINDS } from "./constants";

export default function DeactivationNotice() {
  return (
    <main className="ps-center">
      <section className="ps-card" aria-labelledby="ps-title">
        <img src="/snb-logo.png" alt="Grupo SNB" className="ps-logo" />

        <h1 id="ps-title" className="ps-title">O SIMEMP está sendo desativado</h1>
        <p className="ps-text">
          O sistema passou a fazer parte do <strong>Grupo SNB</strong>. As solicitações pelo
          Ploomes continuam aqui e agora abrem direto, sem precisar entrar com usuário e senha.
        </p>

        <div className="ps-actions">
          <a className="ps-button ps-button--primary" href={REQUEST_KINDS.operational.path}>
            {REQUEST_KINDS.operational.title}
          </a>
          <a className="ps-button ps-button--primary" href={REQUEST_KINDS.administrative.path}>
            {REQUEST_KINDS.administrative.title}
          </a>
        </div>

        <div className="ps-divider" />

        <p className="ps-text ps-text--small ps-text--last">
          Em breve, os colaboradores receberão por e-mail o convite para acessar o novo sistema do
          Grupo SNB. Fique de olho na sua caixa de entrada.
        </p>
      </section>
    </main>
  );
}
